import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';

import { CategoryHelps } from '@app/shared/models/helps.model';
import { Observable } from 'rxjs';

@Injectable()
export class CategoryHelpsDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }


  /**
   * Metodo que devuelve todas las categorias ayudas registradas
   *
   * @return {*}  {Observable<CategoryHelps[]>}
   * @memberof CategoryHelpsDataService
   */
   getCategoryHelps(): Observable<CategoryHelps[]> {
    return new Observable(obs => {
        this.http.skipErrorHandler().get<CategoryHelps[]>(this.api.get('adminCategoryHelps')).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

 
  /**
   * Metodo que permite agregar una categoría de ayuda.
   *
   * @param {CategoryHelps} category
   * @return {*}  {Promise<boolean>}
   * @memberof CategoryHelpsDataService
   */
  cretateCategoryHelp(category: CategoryHelps): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('adminCategoryHelps'), category).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'categoria creada correctamente');
          resolve(true);
        },
        err => {
          if (err.status === 400) {
            if (err.error.nombre) {
              this.toastr.warning('Error al ejecutar operacion', err.error.nombre[0]);
            } else if (err.error.detail) {
              this.toastr.warning(err.error.detail);
            }
          } else if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }
  
  /**
   * Metodo que permite modificar una categoría de ayuda
   *
   * @param {number} id
   * @param {CategoryHelps} category
   * @return {*}  {Promise<boolean>}
   * @memberof CategoryHelpsDataService
   */
  updateCategoryHelp(id: number, category: CategoryHelps): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('adminCategoryHelps', [id]), category).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'categorias de Ayuda modificada correctamente');
          resolve(true);
        },
        err => {
          reject(err);
        }
      );
    });
  }


  
  /**
   * Metodo que permite eliminar una categoría ayuda
   *
   * @param {number} id
   * @return {*}  {Promise<boolean>}
   * @memberof CategoryHelpsDataService
   */
  deleteCategoryHelp(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().delete<boolean>(this.api.get('adminCategoryHelps', [id])).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Categoría eliminada correctamente');
          resolve(true);
        },
        err => {
          if (err.status === 400) {
            this.toastr.warning('Error al ejecutar operacion', err.error.detail);
          } else if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/administration/management_helps/category-help-component/shared/category-help-component.data.service.ts